'use client';

import { useDeviceType, DEVICE_TYPE } from '@libs/common-next';
import { FooterNav, Accordion, AccordionPanel, Heading } from '@petsmart-ui/sparky';
import { propsMapper } from '../../../utils';
import './FooterMainMenu.scss';
import { FooterSubCategories } from './FooterSubCategories';
import type { ContentfulFooterMainNavigation, FooterMainMenuProps } from './types';

export function FooterMainMenu({ categories: categoryEntries }: FooterMainMenuProps) {
    const deviceType = useDeviceType();

    if (!categoryEntries || categoryEntries.length === 0) {
        return null;
    }

    const categories = propsMapper<ContentfulFooterMainNavigation>(categoryEntries);
    return (
        <FooterNav data-testid="footer-main-menu" className="footer__main-menu">
            {deviceType !== DEVICE_TYPE.DESKTOP ? (
                <Accordion borderTop={false}>
                    {categories.map(({ sysId, internalTitle, subCategories }) => (
                        <div data-testid="footer-mobile-category" key={sysId}>
                            <AccordionPanel
                                iconSize="md"
                                header={
                                    <Heading size="body-lg-bold" tagName="h3">
                                        {internalTitle}
                                    </Heading>
                                }
                            >
                                <FooterSubCategories categories={subCategories} />
                            </AccordionPanel>
                        </div>
                    ))}
                </Accordion>
            ) : (
                categories.map(({ sysId, internalTitle, subCategories }) => (
                    <div data-testid="footer-desktop-category" className="categories" key={sysId}>
                        <Heading size="body-lg-bold" tagName="h3">
                            {internalTitle}
                        </Heading>
                        <FooterSubCategories categories={subCategories} />
                    </div>
                ))
            )}
        </FooterNav>
    );
}
